import { Component, input, model, OnChanges, OnInit, output, SimpleChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { EntityFieldComponent } from './entity-field.component'

@Component({
  selector: 'app-entity-text-field',
  imports: [
    FormsModule,
    EntityFieldComponent,
  ],
  template: `
    <div
        app-entity-field
        [id]="id()"
        [label]="label()"
        [validationMessage]="validationMessage()"
    >
      <input
          class="form-control"
          [id]="id()"
          [type]="inputType()"
          [(ngModel)]="model"
          (blur)="coerce()"
      />
    </div>
  `,
})
export class EntityTextFieldComponent<T extends string | number> implements OnInit, OnChanges {
  readonly id = input.required<string>()
  readonly label = input.required<string>()
  readonly inputType = input.required<'text' | 'number'>()
  readonly value = input.required<T | undefined>()
  readonly validationMessage = input<string>()
  readonly valueChange = output<T | undefined>()

  protected readonly model = model<string>('')

  protected coerce() {
    const modelValue = this.model()
    if (modelValue.trim() !== modelValue) {
      this.model.set(modelValue.trim())
    }
  }

  private modelChanged(rawValue: string) {
    const parseModel = (): { valid: boolean, value?: string | number } => {
      if (rawValue === '') {
        return { valid: true }
      } else if (this.inputType() == 'number') {
        const result = Number(rawValue)
        return isNaN(result) ? { valid: false } : { valid: true, value: result }
      } else {
        return { valid: true, value: rawValue }
      }

    }
    const { valid, value } = parseModel()
    if (valid && this.value() !== value) {
      this.valueChange.emit(value as T)
    }
  }

  private refreshModel() {
    this.model.set(String(this.value() ?? ''))
  }

  ngOnInit() {
    this.model.subscribe(rawValue => {
      this.modelChanged(rawValue)
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.refreshModel()
    }
  }
}
